export function toteValidate(tote){
    var result = true;

    result = validateId(tote.id);
    result = validateName(tote.name);
    result = validateShipmentId(tote.shipment_id);
    result = validateShipmentType(tote.shipment_type);
    result = validateSlotId(tote.slot_id);
    result = validateSlot(tote.slot);
    result = validateWarehouseId(tote.warehouse_id);
    result = validateWarehouse(tote.warehouse);

    return result;
}

function validateId(id){    
    if(Number.isInteger(id)) return true;
    else return false;
}

function validateName(name){
    if(typeof name === 'string' && name.trim() !== '') return true;
    else return false;
}

function validateShipmentId(shipment_id){    
    if(shipment_id == null) return true;
    else if(Number.isInteger(shipment_id)) return true;
    else return false;
}

function validateShipmentType(shipment_type) {
    if(typeof shipment_type === 'string' && shipment_type.trim() !== '') return true;
    else return false;
}

function validateSlotId(slot_id) {
    if(slot_id == null) return true;
    else if(Number.isInteger(slot_id)) return true;
    else return false;
}

function validateSlot(slot) {
    slot;
    return true;
}

function validateWarehouseId(warehouse_id) {
    if(Number.isInteger(warehouse_id)) return true;
    else return false;
}

function validateWarehouse(warehouse) {
    warehouse
    return true;
}
// function validateUser(user){
//     if(user == null) return true;
//     if(!Number.isInteger(user.id)) return false;
//     if(typeof user.name !== 'string' || user.name.trim() === '') return false;
//     if(typeof user.paternal_surname !== 'string' || user.paternal_surname.trim() === '') return false;
//     if(typeof user.email !== 'string' || user.email.trim() === '') return false;
// }

// function validateWarehouse(warehouse){
//     if(!Number.isInteger(warehouse.id)) return false;
//     if(typeof warehouse.name !== 'string' || warehouse.name.trim() === '') return false;
// }

// function validateSlots(slots){
//     return Array.isArray(slots) &&
//         slots.every(item =>
//         typeof item === 'object' &&
//         item !== null &&
//         typeof item.id === 'number' &&
//         !isNaN(item.id) &&
//         typeof item.name === 'string' &&
//         item.name.trim() !== ''&&
//         (typeof item.tote_id === 'number' || item.tote_id == null) &&
//         (typeof item.tote_id === 'number' || item.tote_id == null) &&
//         typeof item.position === 'number'
//     );
// }